var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"py-3",class:_vm.props.classes},[_vm._v(_vm._s(_vm.props.item[_vm.props.value]))])}
var staticRenderFns = []

export { render, staticRenderFns }